import { useRef, useEffect, useState } from 'react';
import {
  deletedDuplicateByAuthor,
  getActiveState,
} from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';
import { v4 as uuidv4 } from 'uuid';
import { loadVideos } from '../helpers/preload';

export const useCarousel = () => {
  const {
    user,
    carousel = 1,
    repeatCount = 10,
    startFrom,
    speedSlow = 6750,
  } = useGetParams();
  const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const [showedMessages, setShowedMessages] = useState([]);

  const lastMessageIdRef = useRef(0);
  const nextMessageIndexRef = useRef(-1);
  const messagesRef = useRef([]);

  const rotate = useRef('+');
  const serialNumber = useRef(0);

  const [activeSharkRight, setActiveSharkRight] = useState(false);
  const [activeSharkLeft, setActiveSharkLeft] = useState(false);

  // id предыдущего запущенного интерактива
  const prevIdBroadcast = useRef('');
  // id текущего запущенного интерактива
  const iactiveIdRef = useRef('');

  const protocol = window?.location.protocol || 'https:';

  const getBroadcastInfo = async () => {
    try {
      if (!user) {
        return;
      }

      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`,
        { cache: 'no-store' },
      );
      const data = await response.json();
      if (!data) return;
      let { messagesList, deletedMessagesIdList, visibility, iactiveId } = data;

      // очистка при остановке\смене интерактива, при остановке iactiveId = ""
      if (iactiveIdRef.current !== iactiveId) {
        if (
          // currentMessage &&
          iactiveId &&
          iactiveId !== prevIdBroadcast.current // если === , значит prevIdBroadcast был остановлен и теперь запущен, и не нужно обнулять
        ) {
          messagesRef.current = [];
          setShowedMessages([]);
          nextMessageIndexRef.current = -1;
        }
      }

      // сохранение id нового запущенного интерактива.
      if (iactiveId && iactiveId !== prevIdBroadcast.current) {
        // Если уже был предыдущий запущенный интерактив, то показать сообщение сразу без задержки.
        if (prevIdBroadcast.current) {
          // console.log('смена интреактива');
        }
        prevIdBroadcast.current = iactiveId;
      }

      // Определяем видимость титра
      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      // Определяем состояние (S1, S2 ...)

      const newStates = data?.statusList[0]?.state;

      if (!getActiveState(newStates)) {
        setShowedMessages([]);
        serialNumber.current = 0;
        rotate.current = '+';
      }

      if (newStates && getActiveState(newStates) !== currentState) {
        setCurrentState(getActiveState(newStates));

        if (getActiveState(newStates) === 'S1') {
          setShowedMessages([]);
          serialNumber.current = 0;
          rotate.current = '+';
        }
      }

      // если список сообщений пустой
      if (Array.isArray(messagesList) && messagesList.length === 0) {
        // если имеются в списке сообщений удаленные
        if (
          messagesRef.current.some((el) =>
            deletedMessagesIdList.includes(+el.id),
          )
        ) {
          const newState = messagesRef.current.filter(
            (el) => !deletedMessagesIdList.includes(+el.id),
          );

          for (let i = 0; i < messagesRef.current.length; i++) {
            if (
              !newState.find(
                (el) =>
                  nextMessageIndexRef.current &&
                  el.id ===
                    messagesRef.current[nextMessageIndexRef.current]?.id,
              )
            ) {
              if (
                messagesRef.current[nextMessageIndexRef.current] ===
                messagesRef.current[messagesRef.current.length - 1]
              ) {
                nextMessageIndexRef.current--;
                if (nextMessageIndexRef.current < 0)
                  nextMessageIndexRef.current = 0;
              }
            }
            if (
              i < nextMessageIndexRef.current &&
              !newState.find((el) => el.id === messagesRef.current[i].id)
            ) {
              nextMessageIndexRef.current--;
              if (nextMessageIndexRef.current < 0)
                nextMessageIndexRef.current = 0;
            }
          }
          messagesRef.current = newState;

          if (newState.length < startFrom) {
            setShowedMessages([]);
          }
        }

        //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов

        if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
          lastMessageIdRef.current = 0;
          iactiveIdRef.current = iactiveId;
          return;
        } else {
          iactiveIdRef.current = iactiveId;
          lastMessageIdRef.current =
            messagesList[0]?.id || lastMessageIdRef.current;
        }
        return;
      }

      //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
      if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        iactiveIdRef.current = iactiveId;
        return;
      } else {
        iactiveIdRef.current = iactiveId;
        lastMessageIdRef.current =
          messagesList[0]?.id || lastMessageIdRef.current;
      }

      // Удаляем сообщения, если они не содержат видео.
      messagesList = messagesList.filter(
        (el) =>
          Array.isArray(el.message.attachments) &&
          el.message.attachments.length > 0 &&
          typeof el.message.attachments[0] === 'object' &&
          el.message.attachments[0].type === 'video',
      );

      // попытка предзагрузки вложений
      let urls = messagesList
        ?.map((m) => m.message?.attachments?.[0]?.url)
        ?.filter((u) => u);
      if (urls && urls.length !== 0) {
        loadVideos(urls);
      }

      const result = [...messagesRef.current, ...messagesList.reverse()];

      // messagesRef.current = deletedDuplicateByAuthor(
      //   result,
      //   nextMessageIndexRef
      // ).slice(-repeatCount);

      messagesRef.current = result.slice(-repeatCount);
    } catch (error) {
      console.error(error);
    }
  };

  const iterateIndex = (array) => {
    if (carousel === '1') {
      if (!array.length) {
        nextMessageIndexRef.current = -1;
        return;
      }
      if (nextMessageIndexRef.current < array.length - 1) {
        nextMessageIndexRef.current++;
      } else {
        if (messagesRef.current.length >= startFrom) {
          messagesRef.current = messagesRef.current.slice(-repeatCount);
          nextMessageIndexRef.current = 0;
        }
      }
    } else {
      if (nextMessageIndexRef.current < messagesRef.current.length - 1)
        nextMessageIndexRef.current++;
      else {
        nextMessageIndexRef.current = messagesRef.current.length - 1;
      }
    }
  };

  const updateShowedMessages = (newMessages) => {
    if (newMessages && messagesRef.current.length >= startFrom) {
      if (rotate.current === '+') {
        rotate.current = '-';
      } else {
        rotate.current = '+';
      }

      serialNumber.current = serialNumber.current + 1;

      if (serialNumber.current % 2) {
        setTimeout(() => {
          setActiveSharkRight((prev) => !prev);
        }, 8000 + 1500);
      } else {
        setTimeout(() => {
          setActiveSharkLeft((prev) => !prev);
        }, 7000 + 1500);
      }

      const currentMessageWithUUID = {
        ...newMessages,
        UUID: uuidv4(),
        rotateSign: rotate.current,
        randomDelay: Math.random(),
        serialNumber: serialNumber.current,
      };

      const newMessagesArr = [currentMessageWithUUID, ...showedMessages].slice(
        0,
        5,
      );
      setShowedMessages(newMessagesArr);
    }
  };

  useEffect(() => {
    getBroadcastInfo().then(() => {
      if (messagesRef.current && messagesRef.current.length > 0) {
        iterateIndex(messagesRef.current);
        updateShowedMessages(messagesRef.current[nextMessageIndexRef.current]);
      }
    });
  }, []);

  // Выбор сообщения для показа
  useInterval(
    () => {
      if (messagesRef.current.length >= startFrom) {
        iterateIndex(messagesRef.current);
      }

      if (
        !messagesRef.current[nextMessageIndexRef.current]?.id ||
        (showedMessages.some(
          (el) => el.id === messagesRef.current[nextMessageIndexRef.current].id,
        ) &&
          carousel === '0')
      ) {
        return;
      } else if (carousel === '1' && messagesRef.current.length < startFrom) {
        return;
      } else {
        updateShowedMessages(messagesRef.current[nextMessageIndexRef.current]);
      }
    },
    isVisible && currentState === 'S2' ? speedSlow : null,
  );

  // Получение информации о титре
  useInterval(getBroadcastInfo, 1000);

  return {
    currentState,
    isVisible,
    showedMessages,
    speed: speedSlow,
    activeSharkRight,
    activeSharkLeft,
  };
};
